var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoOuter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52842 15.0003C4.52842 13.861 4.71146 12.7653 5.04922 11.7371L0.765146 10.3451C-1.27883 16.6362 0.85231 23.1953 6.20195 27.0837L8.83211 23.4633C6.22375 21.5572 4.52842 18.477 4.52842 15.0003Z",
    fill: "#2694C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 25.4739C12.6934 25.4739 10.5622 24.7267 8.83206 23.4633L6.2019 27.0837C11.5515 30.9721 18.4462 30.9721 23.798 27.0837L21.1678 23.4633C19.4398 24.7289 17.3087 25.4739 15.001 25.4739Z",
    fill: "#8F3E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2349 10.3451L24.953 11.7371C25.2908 12.7653 25.4738 13.861 25.4738 15.0003C25.4738 18.4791 23.7785 21.5594 21.168 23.4633L23.7981 27.0837C29.1478 23.1953 31.2789 16.6362 29.2349 10.3451Z",
    fill: "#DC396D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0012 4.52448C19.647 4.52448 23.5824 7.55024 24.9531 11.7371L29.235 10.3451C27.191 4.05395 21.6125 0 14.999 0L15.0012 4.52448Z",
    fill: "#6EBD45"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoOuter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoOuter.72c70f62036bb0eaee191ec27fe9d7a8.svg";